export const formatDate = (date?: string, locale = localStorage.i18nextLng || 'en-US') => {
  if (date) {
    return new Date(date).toLocaleDateString(locale);
  }
  return new Date().toLocaleDateString(locale);
};

export const formatTimeLength = (timespan: string) => {
  const [hours, minutes] = timespan.split(':').map(Number);
  return `${hours}h ${minutes}min`;
};
